import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const PHOTOS = [
  { src: "/img/new2-20260921-192036.jpg", alt: "The Archive Room at twilight", id: "twilight" },
  { src: "/img/new2-000042440006.jpg", alt: "The Archive Room on film, a glass of red wine on the table", id: "film" },
];

export default function KitPhotos() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (active === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") setActive((a) => (a + 1) % PHOTOS.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active]);

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mt-8" data-testid="kit-archive-photos">
        {PHOTOS.map((p, i) => (
          <button key={p.id} type="button" onClick={() => setActive(i)} className="relative overflow-hidden group cursor-zoom-in" data-testid={`kit-photo-${p.id}`}>
            <img src={p.src} alt={p.alt} loading="lazy" className="w-full aspect-[3/2] object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
            <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/15 transition-colors" />
          </button>
        ))}
      </div>

      {active !== null && (
        <div className="fixed inset-0 z-[100] bg-ink flex items-center justify-center p-4 md:p-12" onClick={() => setActive(null)} data-testid="kit-lightbox">
          <button className="absolute top-6 right-6 text-parchment/70 hover:text-parchment" onClick={() => setActive(null)} aria-label="Close" data-testid="kit-lightbox-close">
            <X className="w-7 h-7" strokeWidth={1.5} />
          </button>
          <figure className="max-w-6xl max-h-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img src={PHOTOS[active].src} alt={PHOTOS[active].alt} className="max-h-[80vh] w-auto object-contain" data-testid="kit-lightbox-image" />
            <button
              className="mt-4 font-sans text-[0.7rem] uppercase tracking-[0.22em] text-parchment/70 hover:text-parchment"
              onClick={() => setActive((active + 1) % PHOTOS.length)}
              data-testid="kit-lightbox-next"
            >
              Next →
            </button>
          </figure>
        </div>
      )}
    </>
  );
}
